import { render } from "./AnnexItem.vue?vue&type=template&id=98e3e40c&ts=true"
import script from "./AnnexItem.vue?vue&type=script&lang=ts"
export * from "./AnnexItem.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./AnnexItem.vue?vue&type=style&index=0&id=98e3e40c&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__